module.exports = __webpack_public_path__ + "img/billy-team.8f2f53f1.svg";